import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { MemberAuthProvider, useMemberAuth } from "@/context/MemberAuthContext";
import { ContentProvider } from "@/context/ContentContext";
import Landing from "@/pages/Landing";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import GuidesIndex from "@/pages/GuidesIndex";
import GuidePage from "@/pages/GuidePage";
import Preview from "@/pages/Preview";
import PortalLogin from "@/pages/portal/PortalLogin";
import SetPassword from "@/pages/portal/SetPassword";
import ForgotPassword from "@/pages/portal/ForgotPassword";
import Dashboard from "@/pages/portal/Dashboard";
import NodeView from "@/pages/portal/NodeView";
import Account from "@/pages/portal/Account";
import DoneForYou from "@/pages/portal/DoneForYou";
import AllyPage from "@/pages/portal/AllyPage";

const Loading = () => (
  <div className="min-h-screen bg-[#050505] flex items-center justify-center">
    <span className="font-mono text-xs uppercase tracking-[0.3em] text-white/40">Authenticating…</span>
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

const MemberRoute = ({ children }) => {
  const { member } = useMemberAuth();
  if (member === null) return <Loading />;
  if (!member) return <Navigate to="/portal/login" replace />;
  return children;
};

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
      <AuthProvider>
        <MemberAuthProvider>
          <ContentProvider>
            <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#0a0a0a", border: "1px solid rgba(255,255,255,0.1)", color: "#fff", fontFamily: "JetBrains Mono, monospace", fontSize: "13px" } }} />
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/guides" element={<GuidesIndex />} />
              <Route path="/guides/:slug" element={<GuidePage />} />
              <Route path="/preview" element={<Preview />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/login" element={<Login />} />
              <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />

              {/* Member portal */}
              <Route path="/portal/login" element={<PortalLogin />} />
              <Route path="/portal/set-password" element={<SetPassword />} />
              <Route path="/portal/forgot-password" element={<ForgotPassword />} />
              <Route path="/portal" element={<MemberRoute><Dashboard /></MemberRoute>} />
              <Route path="/portal/node/:slug" element={<MemberRoute><NodeView /></MemberRoute>} />
              <Route path="/portal/account" element={<MemberRoute><Account /></MemberRoute>} />
              <Route path="/portal/done-for-you" element={<MemberRoute><DoneForYou /></MemberRoute>} />
              <Route path="/portal/ally" element={<MemberRoute><AllyPage /></MemberRoute>} />
            </Routes>
          </ContentProvider>
        </MemberAuthProvider>
      </AuthProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
